import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

@Component({
  selector: 'app-contact-page',
  templateUrl: './contact-page.component.html',
  styleUrls: ['./contact-page.component.scss']
})
export class ContactPageComponent implements OnInit {
  isToggled = false;
  isSubmitting = false;

  @ViewChild('campusMapSection') campusMapSection?: ElementRef<HTMLElement>;

  private readonly backendUrl = 'http://localhost:3000/send-email';

  constructor(
    public themeService: ThemeCustomizerService,
    private http: HttpClient
  ) {
    this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });
  }

  ngOnInit(): void {}

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  scrollToMap(): void {
    this.campusMapSection?.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  submit(formValue: any, contactForm?: any): void {
    if (this.isSubmitting) return;

    const { name, email, number, subject, message } = formValue || {};

    const formData = {
      name,
      email,
      number,
      subject,
      message
    };

    this.isSubmitting = true;

    this.sendEmail(formData)
      .pipe(finalize(() => (this.isSubmitting = false)))
      .subscribe(
        (response) => {
          console.log('Email sent successfully', response);
          alert('Message sent successfully!');
          contactForm?.resetForm();
        },
        (error) => {
          console.error('Error sending email', error);
          alert('There was an error sending your message. Please try again.');
        }
      );
  }

  sendEmail(formData: any): Observable<any> {
    return this.http.post(this.backendUrl, formData).pipe(
      catchError((error) => {
        console.error('Error sending email:', error);
        return throwError(() => error);
      })
    );
  }
}